module.exports = function() {
  return new Worker(__webpack_public_path__ + "f38a1f539cd223949b4c.worker.js");
};